export const dedupe = <Type>(array: Type[], key: string): Type[] => {
  return [
    ...new Map(
      array.map((item) => [(item as Record<string, unknown>)[key], item]),
    ).values(),
  ]
}
